/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmSablonaPostovnichZasilek extends GContentBase<SeznamAdmSablonaPostovnichZasilekObj> {
        private seznamObj: SeznamAdmSablonaPostovnichZasilekObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmSablonaPostovnichZasilekObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmSablonaPostovnichZasilek",
                contentCaption: "jres:33000253", //RC 33000253 : Šablony poštovních zásilek
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{zkratka}"
                },
                gridSettings: {
                    columnOrder: "druh_zas_txt,sablona_sluzeb,zkratka,nazev,zmenu_prov_txt,dat_zmena,filtr_format"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmSablonaPostovnichZasilekObj extends GAdmSeznamBase {
        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmSablonaPostovnichZasilek", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmSablonaPostovnichZasilek",
                newRecord: isNew,
                druh_zas: isNew == true ? null : data.druh_zas,
                sablona_sluzeb: isNew == true ? null : data.sablona_sluzeb,
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*"])
        }

        createFilterForm() {
            
        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any) {
            this.cnt.isl.AdmSablonaPostovnichZasilek.list({ filters: filterData }).getView().done((data) => {
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {
            this.cnt.actions.actOpenSslDenik?.update({ enabled: objArr.count > 0 })
        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}#{1}#".format(data.druh_zas, data.sablona_sluzeb),
                nazev: ""
            }
        }
    }
}